import {input} from '@angular/core';

export enum Operator {
  IS = 'is',
  IS_NOT = 'is not',
  YES = 'yes',
  NO = 'no',
  IS_SET = 'is set',
  IS_EMPTY = 'is empty',
}

export enum FilterField{
  PDF_AVAILABLE = 'PDF available',
  SELF_CREATED = 'Self created',
  TITLE_ABSTRACT_SCREENING = 'Title/Abstract Screening',
  FULL_TEXT_SCREENING = 'Full-Text Screening',
  MANUEL = 'Manual',
  PROPERTY = 'Property',
}

export enum FilterValue{
  AUDITED = 'audited',
  PASSED = 'passed',
  ACCEPTED = 'accepted',
  OVERWRITTEN = 'overwritten',
}

export enum FilterValueProperty {
  SEMANTIC_SCHOLAR_ID = 'semanticScholarId',
  DOI = 'doi',
  CORPUS_ID = 'corpusId',
  MAG_ID = 'magId',
  PUB_MED_ID = 'pubMedId',
  TITLE = 'title',
  ABSTRACT_TEXT = 'abstractText',
  VENUE = 'venue',
  REFERENCE_COUNT = 'referenceCount',
  CITATION_COUNT = 'citationCount',
  IS_OPEN_ACCESS = 'isOpenAccess',
  AUTHORS = 'authors',
  YEAR = 'year',
  SOURCE = 'source',
  URL = 'url',
  PDF_URL = 'pdfUrl'
}

export interface FilterBlock {
  filter: FilterField;
  possibleOperators: Operator[];
  operator?: Operator;
  value?: string;
  possibleValues: string[];
}


export enum CUSTOM_FILTER {
  ALL_IDENTIFIED_ARTICLES = 'All identified Articles',
  PDF_DOWNLOADED = 'PDF downloaded',
  TITLE_ABSTRACT_SCREENING_AUDITED = 'Title/Abstract screening - audited',
  FULL_TEXT_SCREENING_AUDITED = 'Full-Text screening - audited',
  TITLE_ABSTRACT_SCREENING_PASSED = 'Title/Abstract screening - passed',
  FULL_TEXT_SCREENING_PASSED = 'Full-Text screening - passed',
  MANUAL_ACCEPTED = 'Manual accepted',
  MANUAL_OVERWRITTEN = 'Manual overwritten'
}
